(function () {
    'use strict';

    angular
        .module('app', [

            'env',
            'settings',

            'ng-fastclick', // avoid conflict with Bootstrap by using class "dropdown-toggle"
            'ngSanitize',
            'ui.router',
            'auth', // services/auth.js
            'ui.bootstrap',
            'ui.bootstrap.tooltip',
            'ui.slimscroll',
            'xeditable',
			'ng-clipboard',
			'ngPapaParse',
            'ngFileSaver',

            'app.routes',
            'app.filters',

            'app.directives',
            'app.controllers',

            'app.ui',
            'app.charts',
			'app.live-editor'
        ])
        .config(config)
        .run(run);

    function config($httpProvider, $compileProvider) {

        $httpProvider.interceptors.push('AuthInterceptor');

        // https://code.angularjs.org/1.5.5/docs/guide/production
        $compileProvider.debugInfoEnabled(false);
    }

    function run($rootScope, $state, AuthFactory, DataFactory, CONFIG, SETTINGS) {

        $rootScope.SETTINGS = SETTINGS;
        $rootScope.menuOpen = false;
        $rootScope.$state = $state;
        $rootScope.retroMonths = ['November 2017', 'December 2017', 'January 2018', 'February 2018', 'March 2018', 'April 2018'];

		$rootScope.allowEditingContent = SETTINGS.ALLOW_EDITING_CONTENT;

        $rootScope.dataFilter = DataFactory.getFilterOptions();
		$rootScope.dataFilterSelected = $rootScope.dataFilter[0];

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

            // Close menu when changing state
            $rootScope.menuOpen = false;

            console.log('Entering state:', toState.name);
            var params = [];
            angular.forEach(toParams, function (p, key) {
                params.push(key + ' = ' + p);
            });

            if (params.length) {
                console.log('Params:        ', params.join(', '));
            }

            // Halt state change if auth required and no token present
            if (SETTINGS.AUTH.TYPE == 'token' && CONFIG.ENV != 'dev') {

                /**
                 * retrieve requireLogin property boolean value of the toState route.
                 * prevent state change when route requires login and token is not yet set.
                 * else allow state change when token is set.
                 */
                var isRestricted = true;

                if (typeof toState.views != 'undefined' && typeof toState.views.data != 'undefined') {
                    isRestricted = toState.views.data.requireLogin;
                }

                if (isRestricted && !AuthFactory.hasToken()) {
                    console.log('Access to requested state is restricted and no token was found');
                    event.preventDefault();
                    $state.go('auth.login');
                }
            }
        });
    }

})();